import { defineAction } from '~/prix'
import { z } from 'zod'
import collectionIncentiveCreateAction from './collectionIncentiveCreate.action.json' with { type: 'json' }
import { collectionIncentiveObject } from '../collectionIncentiveObject'

const animalInput = z.object({
  earringNumber: z.number().int(),
  species: z.string().nullish(),
  weight: z.number().nullish(),
  unitValue: z.number().nullish(),
  discountValue: z.number().nullish(),
})

const collectionIncentiveCreateDefinition = defineAction({
  ...collectionIncentiveCreateAction,

  input: z.object({
    id: collectionIncentiveObject.shape.id.optional(),
    benefitProgramId: collectionIncentiveObject.shape.benefitProgramId,
    citizenId: collectionIncentiveObject.shape.citizenId,
    animals: z.array(animalInput).min(1).max(5000),
    notes: z.string().nullish(),
  }),
  output: z.object({ id: collectionIncentiveObject.shape.id }),
})

export default collectionIncentiveCreateDefinition
